import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ArticulosService } from 'src/app/services/articulos.service'; 
import { articulo,partida } from 'src/app/models/articulos/alta-articulo'; 
import Swal from 'sweetalert2';
import { PartidasService } from 'src/app/services/partidas.service'; 
import { Subscriber } from 'rxjs';

@Component({
  selector: 'app-alta-articulo',
  templateUrl: './alta-articulo.component.html',
  styleUrls: ['./alta-articulo.component.css']
})
export class AltaArticuloComponent implements OnInit {

   articulo: articulo = {

    clave: '',
    descripcion: '',
    esActivo: true,
    esBasico: true
  }

  partidas: partida[];
  loading = false;

 constructor(private artSrv: ArticulosService, private partSrvc: PartidasService) { }


  ngOnInit(): void{
    this.partSrvc.listarPartidas().subscribe({
      next: (resp) => this.partidas = resp.partidas || [], 
      error: () => this.partidas = []
    });
  }

  guardarArticulo(f: NgForm){

    if(f.invalid || this.loading){
      f.control.markAllAsTouched();
      return;
    }

    this.loading = true;

    this.articulo.clave = this.articulo.clave?.toUpperCase()?.trim();
    this.articulo.descripcion = this.articulo.descripcion?.trim();

    this.artSrv.crearArticulo({
      clave: this.articulo.clave,
      id_partidas: this.articulo.id_partidas,
      descripcion: this.articulo.descripcion,
      esActivo: this.articulo.esActivo ?? true,
      esBasico: this.articulo.esBasico ?? true
    }).subscribe({
      next: (resp) => {
        if(resp?.ok){
          Swal.fire({
           title: 'Guardado',
           icon: 'success',
           text: 'Articulo guardado correctamente' 
          });
        }else{
          Swal.fire({
            title: 'Error',
            icon: 'warning',
            text: 'No se pudo guardar el articulo'
          });
        }
        this.loading = false;
      }
    });

  }



}